/**
 * Quill personality bank — pre-curated lines for every app state.
 *
 * Centralised here so the mascot has a *consistent voice* whether it's
 * greeting a cold visitor, scolding a 500, or celebrating a finished
 * path. Each surface picks one bucket; we randomise within so users see
 * variety on repeat visits without sounding canned.
 */

const pick = (lines) => lines[Math.floor(Math.random() * lines.length)];

export const QUILL_LINES = {
  // Landing / hero — first impression for cold visitors.
  greeter: [
    "Hi, I'm Quill — let's master something today.",
    "Pick any topic. I'll write the playbook in 30 seconds.",
    "I scribed for the Magna Carta. Now I write for you.",
  ],
  // Hub empty dashboard
  empty_dashboard: [
    "Your slate's clean. Type a goal — I'll do the rest.",
    "Tell me what you want to learn. I'll bring the path.",
    "Nothing here yet. Plant a goal and watch it grow.",
  ],
  // Library empty
  empty_library: [
    "No saves yet. Bookmark a path and I'll keep it safe.",
    "Your library's quiet. Save a path to come back to.",
  ],
  // Loading — path generation, exam, etc.
  loading_long: [
    "Sketching your path. Thirty seconds.",
    "Pulling threads together. Hold on.",
    "Distilling. This is the fun part.",
  ],
  // Generic error
  error: [
    "Something tripped. Try once more?",
    "I dropped a quill. Refresh and we'll retry.",
  ],
  // Generic success / celebration
  celebrate: [
    "Path's ready. Go make it yours.",
    "Done. You've earned this.",
    "That's the one. Dive in.",
  ],
  // Cert / mastery moment
  mastery: [
    "Witnessed. You showed up. That's mastery.",
    "Stamped and signed. Wear this proudly.",
  ],
  // No credits left
  no_credits: [
    "You're out of ink. Top up or watch a 30-sec ad — your call.",
    "I'm out of pages. Grab more credits and we'll keep going.",
  ],
};

export function pickQuillLine(bucket, fallback = "Hi.") {
  const lines = QUILL_LINES[bucket];
  if (!lines || lines.length === 0) return fallback;
  return pick(lines);
}
